/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AdmissionGridDto } from './AdmissionGridDto';
import {
    AdmissionGridDtoFromJSON,
    AdmissionGridDtoFromJSONTyped,
    AdmissionGridDtoToJSON,
} from './AdmissionGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface AdmissionGridDtoPaginatedResults
 */
export interface AdmissionGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof AdmissionGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<AdmissionGridDto>}
     * @memberof AdmissionGridDtoPaginatedResults
     */
    results?: Array<AdmissionGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof AdmissionGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the AdmissionGridDtoPaginatedResults interface.
 */
export function instanceOfAdmissionGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AdmissionGridDtoPaginatedResultsFromJSON(json: any): AdmissionGridDtoPaginatedResults {
    return AdmissionGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function AdmissionGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdmissionGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(AdmissionGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function AdmissionGridDtoPaginatedResultsToJSON(value?: AdmissionGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(AdmissionGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

